import { useMutation } from '@apollo/client';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

import { DEACTIVATE_AGENT } from '../../graphql/agent';
import ErrorView from '../../components/common/ErrorView';
import { SatelliteAgentListItemFragment } from './SatelliteAgentListItem';
import { FragmentType, useFragment } from '../../__generated__';

type DeleteAgentDialogProps = {
  open: boolean;
  agent: FragmentType<typeof SatelliteAgentListItemFragment>;
  onClose: (deleted?: boolean) => void;
};

const DeleteSatelliteAgent = (props: DeleteAgentDialogProps) => {
  const { open, onClose } = props;
  const agent =
    useFragment(SatelliteAgentListItemFragment, props.agent) || null;
  const [deleteAgent, { loading, error }] = useMutation(DEACTIVATE_AGENT);

  const deleteAgentFunc = async () => {
    const result = await deleteAgent({
      variables: {
        id: agent.id,
      },
    });

    if (result?.data?.deactivateAgent?.success) {
      onClose(true);
    }
  };

  const cancel = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={cancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {'Delete Satellite Agent'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {`Are you sure you want to delete the satellite agent ${agent.name}?`}
        </DialogContentText>
        {error && <ErrorView message={error?.message} />}
      </DialogContent>
      <DialogActions>
        <Button onClick={cancel}>Cancel</Button>
        <Button onClick={deleteAgentFunc} disabled={loading}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSatelliteAgent;
